import { render, staticRenderFns } from "./DetalheImagemProduto.vue?vue&type=template&id=314aa6d8"
import script from "./DetalheImagemProduto.vue?vue&type=script&lang=js"
export * from "./DetalheImagemProduto.vue?vue&type=script&lang=js"
import style0 from "./DetalheImagemProduto.vue?vue&type=style&index=0&id=314aa6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports